import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MainPage } from "./pages/main_page/index";
import { Food } from "./pages/food/index";
import { PokerPage } from "./pages/poker/index";
import BlogPost from "./components/blog/blogPost";
import ScrollToTop from "./components/scrollToTop";
import json from "./components/blog/posts.json";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/food" element={<Food />} />
        <Route
          path="/food/:post"
          element={<BlogPost postsJson={json} fallback="food" />}
        />
        <Route path="/blog" element={<Food />} />
        <Route path="/poker" element={<PokerPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
